export const displayStaffStatus = (data) => {
  if (data && data.inviteSent) {
    return data.status
  } else if (data && !data.inviteSent) {
    return 'CREATED'
  } else {
    return '-'
  }
}
